import { displayTextOf } from '@repo/shared/orpc/multi-language';
import { SearchField } from 'component/form';
import { InformationalModal } from 'component/modal/informational-modal';
import { useSiloLanguage } from 'component/translation';
import { TextButton } from 'component/ui/text-button';
import { type Space, useSpaceSearch } from 'data/spaces';
import { useState } from 'react';
import { View } from 'react-native';
import { t } from 'util/stdtypes';

type QuestionSelectorModalProps = {
    onClose: () => void;
    onSelect: (question: Space) => void;
};

/**
 * Picks the space a video voting links to, from a search over the silo's
 * spaces that runs on the server.
 */
export function QuestionSelectorModal({ onClose, onSelect }: QuestionSelectorModalProps) {
    const isoLocale = useSiloLanguage();
    const [search, setSearch] = useState('');
    const { spaces } = useSpaceSearch({ search });
    return (
        <InformationalModal
            content={
                <View style={{ gap: 8 }}>
                    <SearchField onChange={setSearch} placeholderLabel={t('space.table.search', 'Search...')} value={search} />
                    {spaces.map((question) => (
                        <TextButton
                            key={question.spaceKey}
                            onPress={() => {
                                onSelect(question);
                            }}
                            text={displayTextOf(question.name, isoLocale)}
                            variant='primary'
                        />
                    ))}
                </View>
            }
            headingLabel={t('videovoting.select_question', 'Select a question')}
            onClose={onClose}
        />
    );
}
